import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/global.css'

import { queryClient, router } from './router'
import { environmentLabel } from './utils/environment'

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

// The tab says which environment it shows, so a stage is never mistaken for
// production; production keeps the plain name from index.html.
const environment = environmentLabel()
if (environment) document.title = `[${environment}] ${document.title}`

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
